module.exports = __webpack_public_path__ + "static/media/loading2.afd68b2b.gif";